const LISTINGS_SEARCH_UTM_SOURCE_PREFIX = 'listings-search-';
const LISTINGS_SEARCH_UTM_SOURCE_PATTERN = new RegExp(
  `^${LISTINGS_SEARCH_UTM_SOURCE_PREFIX}[a-z]+$`,
);

type MixpanelLike = {
  unregister: (propertyName: string) => void;
  // eslint-disable-next-line camelcase
  get_property: (propertyName: string) => unknown;
  people?: {
    unset?: (propertyName: string) => void;
  };
};

export const clearListingsSearchUtmSourceSuperProperty = (
  mixpanelInstance: MixpanelLike,
): void => {
  // eslint-disable-next-line camelcase
  const utmSource = mixpanelInstance.get_property('utm_source');

  if (typeof utmSource !== 'string') {
    return;
  }

  if (
    utmSource.startsWith(LISTINGS_SEARCH_UTM_SOURCE_PREFIX) &&
    LISTINGS_SEARCH_UTM_SOURCE_PATTERN.test(utmSource)
  ) {
    mixpanelInstance.unregister('utm_source');
    mixpanelInstance.people?.unset?.('initial_utm_source');
  }
};
